<template>
  <div>
    <v-card :light="!$vuetify.theme.dark" class="ma-2" color="#fafafa" elevation="0">
      <v-card-text>
        <router-link to="/">
          <v-img
              :src="$vuetify.theme.dark ? logoWhite : logo"
              max-height="50"
          />
        </router-link>
      </v-card-text>
    </v-card>
    <v-divider/>
    <v-list rounded>
      <template v-for="item in menus">
        <v-list-group
            v-if="item.subMenuItems && haveAccessMenu(item.title)"
            :prepend-icon="item.icon"
            color="#fafafa"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{item.title}}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
              v-if="haveAccessMenu(subMenu.title)"
              v-for="(subMenu, i) in item.subMenuItems"
              :key="i"
              :to="subMenu.path"
              color="#fafafa"
              router
              link
              exact
          >
            <v-list-item-icon>
              <v-icon v-text="subMenu.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="subMenu.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <template v-else>
          <v-list-item
              :to="item.path"
              color="#fafafa"
              router
              link
              exact
              v-if="haveAccessMenu(item.title)"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import pTable from "../../json/pTable.json";
export default {
  name: "AppSidebar",
  data() {
    return {
      menus: [
        {title: 'Dashboard', icon: 'mdi-view-dashboard', path: '/'},
        {title: 'Reports', icon: 'mdi-equal-box', path: '/reports'},
        {title: 'Sites', icon: 'mdi-sitemap', path: '/sites'},
        {title: 'Orders', icon: 'mdi-briefcase', path: '/orders'},
        {
          title: 'Invoices',
          icon: 'mdi-cart-outline',
          subMenuItems: [
            {title: 'Create New Invoice', icon: 'mdi-cart-outline', path: '/invoice'},
            {title: 'Reseller Invoice List', icon: 'mdi-view-list', path: '/invoices'},
            {title: 'Merged Invoice List', icon: 'mdi-view-list', path: '/merged-invoice-list'},
          ]
        },
        {title: 'Broken Links', icon: 'mdi-vector-link', path: '/broken-links'},
        {
          title: 'Clients',
          icon: 'mdi-account-group',
          subMenuItems: [
            {title: 'Client List', icon: 'mdi-format-list-bulleted', path: '/client-list'},
            {title: 'Clients Types', icon: 'mdi-account-network', path: '/client-types'},
          ]
        },
        /*{
          title: 'Clients',
          icon: 'mdi-account-group',
          subMenuItems: [
            {title: 'Fix Clients', icon: 'mdi-account-group', path: '/fix-clients'},
            {title: 'Special Clients', icon: 'mdi-shield-star', path: '/special-clients'},
            {title: 'Agency Clients', icon: 'mdi-alpha-a-circle', path: '/agency-clients'},
          ]
        },*/
        {
          title: 'Mail Box',
          icon: 'mdi-email-box',
          subMenuItems: [
            {title: 'Mail Templates', icon: 'mdi-grid', path: '/mail-templates'},
            {title: 'Mail Box', icon: 'mdi-mailbox', path: '/mail-box'}
          ]
        },
        {
          title: 'Users',
          icon: 'mdi-account',
          subMenuItems: [
            {title: 'Manual Credits', icon: 'mdi-bank', path: '/payments'},
            {title: 'Users', icon: 'mdi-account-multiple', path: '/users'},
            {title: 'Admin Users', icon: 'mdi-handshake', path: '/admins'}
          ]
        },
        {
          title: 'Settings',
          icon: 'mdi-card-bulleted-settings',
          subMenuItems: [
            {title: 'Methods', icon: 'mdi-cash-register', path: '/methods'},
            {title: 'Extra Facilities', icon: 'mdi-postage-stamp', path: '/extra-facilities'},
            {title: 'Niche Categories', icon: 'mdi-code-tags', path: '/niche-categories'},
            {title: 'Task Schedulers', icon: 'mdi-folder-network', path: '/task-scheduler'},
            {title: 'Site Owners', icon: 'mdi-minecraft', path: '/site-owners'},
            {title: 'Site Ownership', icon: 'mdi-lock-reset', path: '/site-ownerships'}
          ]
        },
        {title: 'Background Jobs', icon: 'mdi-message-settings', path: '/background-jobs'},
        {title: 'WP Access', icon: 'mdi-lock', path: '/wp-access-control'},
        {title: 'Logs', icon: 'mdi-database-settings', path: '/logs'},
        /*{title: 'Alfa Coins Currency', icon: 'mdi-currency-btc', path: '/alfa-coins-currency'},*/
        {title: 'Google Analytics', icon: 'mdi-google-analytics', path: '/google-analytics'},
      ],
      logo: require('../../assets/img/logo.png'),
      logoWhite: require('../../assets/img/logo.png'),
    }
  },
  props: {
    miniVariant: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    haveAccessMenu(title) {
      switch (title.toLowerCase()) {
        case 'reports':
          return this.user && this.setPermission(this.user.email, 'report.reportNav');
        default:
          return true;
      }
    },
    setPermission(email, column) {
      let columnSplit= column.split(".");
      let pData = pTable;

      columnSplit.forEach((item) => {
        pData =  pData[item];
      });

      return pData.find(item => item === email);
    }
  }
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  .company-logo-panel {
    width: 100%;
    text-align: center;
    transition: transform .3s ease-in-out, width .3s ease-in-out;

    .image {
      img {
        width: 100%;
        max-width: 100px;
        height: auto;
      }
    }

    .company-name {
      padding: 10px 5px 0px;
      color: #616161 !important;
    }
  }
}
</style>
